import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { UserService } from 'src/app/core/services/user.service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { ApplicationStatus, FocusPayPreApp } from 'src/app/shared/models/FocusPay/FocusPayPreApp.dto';

@Component({
	selector: 'app-application-list-view',
	templateUrl: './application-list-view.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class ApplicationListViewComponent implements OnInit {
	applicationList: FocusPayPreApp[];

	applicationStatusList: GenericLabelValue[] = [];
	@Output() applicationIdSelectedEmitter = new EventEmitter<string>();
	@Output() applicationIdStatusEmitter = new EventEmitter<string>();

	multiSortMeta;

	constructor(public app: AppService, private userService: UserService, private focuslink: FocuslinkService, private router: Router) {}

	ngOnInit(): void {
		Object.keys(ApplicationStatus).forEach((key) => {
			if (isNaN(+key)) {
				this.applicationStatusList.push(
					new GenericLabelValue({
						value: key,
						label: ApplicationStatus[key],
					})
				);
			}
		});
		if (!this.userService.user) {
			setTimeout(() => {
				this.getApplicationsForDealership(this.userService.user.dealerKey);
			}, 250);
		} else {
			this.getApplicationsForDealership(this.userService.user.dealerKey);
		}
	}

	viewApplication(preApp: FocusPayPreApp) {
		this.router.navigate([`cc/payments/focuspay/applications/${preApp.sk}`]);
	}

	async getApplicationsForDealership(dealerKey?: string) {
		if (dealerKey === '0') dealerKey = undefined;
		const resp = await this.focuslink.focuspayPreAppGetAll(dealerKey);
		this.applicationList = resp.map((i) => new FocusPayPreApp(i));
	}
}
